import type { AdminCategory } from './types';

export const parseCommaSeparated = (value: string): string[] =>
  value
    .split(',')
    .map((s) => s.trim())
    .filter(Boolean);

/**
 * Case-insensitive duplicate name check, mirroring the server's uniqueness
 * rule. `excludeId` lets the edit form ignore the category being renamed.
 * A blank name is not a duplicate — the form's own required rule covers it.
 */
export const isDuplicateCategoryName = (
  name: string,
  categories: Pick<AdminCategory, 'id' | 'name'>[],
  excludeId?: string,
): boolean => {
  const normalized = name.trim().toLowerCase();

  if (!normalized) {
    return false;
  }

  return categories.some(
    (category) =>
      category.id !== excludeId &&
      category.name.trim().toLowerCase() === normalized,
  );
};

/**
 * Metrics a category delete would unlink. Soft-deleted metrics still hold a
 * categoryId, but they are invisible in the table, so counting them would
 * contradict what the admin sees on screen.
 */
export const countMetricsInCategory = (
  metrics: { categoryId: string | null; deletedAt: string | null }[],
  categoryId: string,
): number =>
  metrics.filter(
    (metric) => metric.categoryId === categoryId && !metric.deletedAt,
  ).length;
